import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiMail,FiPhone,FiMapPin,FiShield,FiExternalLink,FiClock}=FiIcons;

const Footer=()=> {
  const contactInfo=[
    {icon: FiMail,label: "E-Mail",value: "abuse@malerbetrieb-pelzer.de",link: "mailto:abuse@malerbetrieb-pelzer.de"},
    {icon: FiPhone,label: "Telefon",value: "+49 2454 7403",link: "tel:+4924547403"},
    {icon: FiMapPin,label: "Adresse",value: "Kreuzstr. 2,52538 Birgden",link: null}
  ];

  const quickLinks=[
    {name: "Datenschutz",href: "https://www.malerbetrieb-pelzer.de/datenschutzerklaerung"},
    {name: "Impressum",href: "https://www.malerbetrieb-pelzer.de/impressum"}
  ];

  return (
    <footer className="relative bg-black/40 backdrop-blur-md border-t border-white/10">
      <div className="container mx-auto px-6 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <motion.div 
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{duration: 0.6}}
            className="space-y-4"
          >
            <div className="flex items-center space-x-3">
              <div className="bg-gradient-to-r from-cyan-500 to-purple-600 p-2 rounded-lg">
                <SafeIcon icon={FiShield} className="w-6 h-6 text-white" />
              </div>
              <h3 className="text-xl font-bold text-white">Malerbetrieb Pelzer</h3>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              Ihr vertrauensvoller Partner für professionelle Malerarbeiten und Oberflächentechnik. 
              Wir stehen für Qualität und Zuverlässigkeit in jeder Ausführung.
            </p>
          </motion.div>

          {/* Contact Info */}
          <motion.div 
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{duration: 0.6,delay: 0.1}}
            className="space-y-4"
          >
            <h4 className="text-lg font-semibold text-white flex items-center space-x-2">
              <SafeIcon icon={FiPhone} className="w-5 h-5 text-cyan-400" />
              <span>Kontakt</span>
            </h4>
            <div className="space-y-3">
              {contactInfo.map((item,index)=> (
                <motion.div 
                  key={index}
                  whileHover={{x: 5}}
                  className="flex items-center space-x-3 text-gray-300"
                >
                  <SafeIcon icon={item.icon} className="w-4 h-4 text-cyan-400" />
                  {item.link ? (
                    <a href={item.link} className="text-sm hover:text-cyan-400 transition-colors">
                      {item.value}
                    </a>
                  ) : (
                    <span className="text-sm">{item.value}</span>
                  )}
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Quick Links */}
          <motion.div 
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{duration: 0.6,delay: 0.2}}
            className="space-y-4"
          >
            <h4 className="text-lg font-semibold text-white flex items-center space-x-2">
              <SafeIcon icon={FiExternalLink} className="w-5 h-5 text-purple-400" />
              <span>Links</span>
            </h4>
            <div className="space-y-3">
              {quickLinks.map((link,index)=> (
                <motion.a 
                  key={index}
                  href={link.href}
                  whileHover={{x: 5}}
                  className="block text-gray-300 text-sm hover:text-purple-400 transition-colors"
                  target={link.href.startsWith('http') ? '_blank' : '_self'}
                  rel={link.href.startsWith('http') ? 'noopener noreferrer' : ''}
                >
                  {link.name}
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* Response Times */}
          <motion.div 
            initial={{opacity: 0,y: 30}}
            whileInView={{opacity: 1,y: 0}}
            viewport={{once: true}}
            transition={{duration: 0.6,delay: 0.3}}
            className="space-y-4"
          >
            <h4 className="text-lg font-semibold text-white flex items-center space-x-2">
              <SafeIcon icon={FiClock} className="w-5 h-5 text-green-400" />
              <span>Reaktionszeiten</span>
            </h4>
            <div className="space-y-3 text-sm text-gray-300">
              <div className="flex justify-between items-center">
                <span>Kritisch:</span>
                <span className="text-red-400 font-semibold">&lt;1 Stunde</span>
              </div>
              <div className="flex justify-between items-center">
                <span>Hoch:</span>
                <span className="text-orange-400 font-semibold">&lt;4 Stunden</span>
              </div>
              <div className="flex justify-between items-center">
                <span>Normal:</span>
                <span className="text-green-400 font-semibold">&lt;24 Stunden</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <motion.div 
          initial={{opacity: 0}}
          whileInView={{opacity: 1}}
          viewport={{once: true}}
          transition={{duration: 0.6,delay: 0.4}}
          className="border-t border-white/10 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0"
        >
          <p className="text-gray-400 text-sm">
            © 2024 Malerbetrieb Pelzer. Alle Rechte vorbehalten.
          </p>
          <p className="text-gray-400 text-sm">
            Professionelle Malerarbeiten in Birgden und Umgebung
          </p>
        </motion.div>
      </div>

      {/* Animated background elements */}
      <motion.div 
        className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-cyan-500 via-purple-500 to-pink-500"
        initial={{scaleX: 0}}
        whileInView={{scaleX: 1}}
        viewport={{once: true}}
        transition={{duration: 2,ease: "easeInOut"}}
      />
    </footer>
  );
};

export default Footer;